<div class="card">
  <div class="card-header">
    <div class="media">
      <!-- Community Author image start -->
      <a
        class="media-left media-middle"
        [routerLink]="['/community', community.name]"
      >
        <img
          *ngIf="community.image"
          class="community-preview-community-img"
          [src]="community.image"
          alt="community-image"
        />
        <img
          *ngIf="!community.image"
          class="community-preview-community-img"
          [src]="defaultCommunityImg"
          alt="community-image"
        />
      </a>
      <!-- Community author image end -->

      <div class="media-body media-middle">
        <div class="company-name">
          <!-- Community name start -->
          <a [routerLink]="['/community', community.name]">
            <p>{{ community.name | slice: 0:30 }}</p>
          </a>
          <!-- Community author name end -->

          <span class="text-muted f-14"
            >Created {{ community.createdAt | date: "longDate":"UTC" }}</span
          >
        </div>
      </div>
    </div>
  </div>
  <div class="card-block">
    <!-- Community title start -->
    <a
      [routerLink]="['/community', community.name]"
      class="card-title header-details"
    >
      <h6
        [innerHTML]="community.summary | slice: 0:100"
        class="job-card-desc"
      ></h6>
    </a>
    <!-- Community title end -->

    <!-- Community Description start -->
    <a [routerLink]="['/community', community.name]">
      <p
        [innerHTML]="community.description | slice: 0:150"
        class="text-muted"
      ></p>
    </a>
    <!-- Community description end -->

    <div class="job-lable">
      <span *ngFor="let tag of community.tagList" (click)="setTagFeed(tag)">
        <label class="label badge-success">
          {{ tag | slice: 0:20 }}
        </label>
      </span>
    </div>
    <hr />
    <div class="text-right">
      <!-- Read more button-->
      <a [routerLink]="['/community', community.name]">
        <button
          type="button"
          class="btn btn-info waves-effect waves-light btn-sm footer-button"
        >
          <i class="icofont icofont-people"></i> &nbsp;
          {{ community.memberCount }} &nbsp;
        </button>
        <button
          type="button"
          class="btn btn-info waves-effect waves-light btn-sm footer-button"
        >
          <i class="icofont icofont-radio-mic"></i> &nbsp;
          {{ community.discussionCount }} &nbsp;
        </button>
      </a>
    </div>
  </div>
</div>
